const categories = [
  {
    name: 'Medicamentos',
    slug: 'medicamentos',
  },
  {
    name: 'Belleza',
    slug: 'belleza',
  },
  {
    name: 'Accesorios y dispositivos',
    slug: 'accesorios-y-dispositivos',
  },
  {
    name: 'Cuidado personal',
    slug: 'cuidado-personal',
  },
  {
    name: 'Vitaminas y suplementos',
    slug: 'vitaminas-y-suplementos',
  },
];

export default categories;
